import { useSchoolYear } from '@pelckmans/business-components/context/SchoolYearContext';
import useStudentGroups from '../hooks/useStudentGroups';
import { toId } from '../utils';
import InvitationContext from '../../../contexts/InvitationContext';
import { useContext } from 'react';
import Section from '@pelckmans/elementis/components/section';
import { useTranslation } from 'react-i18next';
import EmptyState from '../../../shared-components/EmptyState';
import ListGroup from '@pelckmans/elementis/components/list-group';
import PendingList from './PendingList';
import AcceptedList from './AcceptedList';
import AccountContext from '../../../contexts/AccountContext';
import useGroupInviteToasts from '../hooks/useGroupInviteToasts';

interface Props extends Required<Pick<ReturnType<typeof useSchoolYear>, 'currentSchoolYear'>> {}

function TeacherSections({ currentSchoolYear }: Props) {
  const { t } = useTranslation();

  const { groups } = useStudentGroups(toId(currentSchoolYear));

  const { pendingInvitations } = useContext(InvitationContext);
  const { account } = useContext(AccountContext);

  const personalGroups = groups?.filter(group => !group.smartschoolGroupId);
  const smartschoolGroups = groups?.filter(group => group.smartschoolGroupId);

  useGroupInviteToasts();

  if (personalGroups.length === 0 && smartschoolGroups.length === 0 && pendingInvitations.length === 0) {
    return (
      <Section
        title={t('PAGES.MY_TEACHERS.CURRENT_YEAR_TAB.TITLE', {
          schoolYearStartYear: currentSchoolYear.from.getFullYear(),
          schoolYearEndYear: currentSchoolYear.to.getFullYear(),
        })}
      >
        <EmptyState
          variant="list"
          headerTitle={t('PAGES.MY_TEACHERS.CURRENT_YEAR_TAB.EMPTY.TITLE')}
          bodyText={t('PAGES.MY_TEACHERS.CURRENT_YEAR_TAB.EMPTY.BODY')}
        />
      </Section>
    );
  }

  return (
    <Section
      title={t('PAGES.MY_TEACHERS.CURRENT_YEAR_TAB.TITLE', {
        schoolYearStartYear: currentSchoolYear.from.getFullYear(),
        schoolYearEndYear: currentSchoolYear.to.getFullYear(),
      })}
    >
      <ListGroup>
        <PendingList />
        <AcceptedList
          schoolYear={toId(currentSchoolYear)}
          allowDisconnect
          headerTitle={t('PAGES.MY_TEACHERS.ACCEPTED_LIST.TITLE')}
          headerTooltip={t('PAGES.MY_TEACHERS.ACCEPTED_LIST.TOOLTIP')}
          groups={personalGroups}
        />
        {account.smartschoolSchools.length !== 0 && (
          <AcceptedList
            schoolYear={toId(currentSchoolYear)}
            headerTitle={t('PAGES.MY_TEACHERS.ACCEPTED_LIST.TITLE_SMARTSCHOOL')}
            headerTooltip={t('PAGES.MY_TEACHERS.ACCEPTED_LIST.TOOLTIP')}
            groups={smartschoolGroups}
          />
        )}
      </ListGroup>
    </Section>
  );
}

export default TeacherSections;
